import { useState } from "react";

import { PageSupport } from "../../components/utilities/page-support";
import { TextInput } from "../../components/forms/text-input";
import { Header } from "../../components/header/header";
import "../../styles/forms.css";
import classNames from "classnames";
import { AppAlert } from "../../components/utilities/alert";
import { Loader } from "../../components/utilities/loader";
import { useAuthentication } from "../../services/authentication/authentication.context";


export const Authentication = () => {

    const { isLoading, authenticate } = useAuthentication();

    const [creds, setCreds] = useState({
        email: '',
        password: ''
    });
    const [onAlert, setOnAlert] = useState();

    const isNull = (v) => v === '' || v === undefined || v === null;

    const validateInput = () => {
        if (isNull(creds.email) || isNull(creds.password)) {
            setOnAlert({
                caption: "Error",
                message: "Input error! email and password cannot be null",
            });
            return false;
        }
        return true;
    }

    const [viewPass, setViewPass] = useState(false);

    return (
        <div className="f-pg">
            <PageSupport />
            <Header />
            {isLoading && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={"OK"}
                    onAccept={() => setOnAlert()}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="flx-c">
                <div className="form-container">
                    <div className="sub-cap">Sign in as admin</div>
                    <TextInput
                        type={'email'}
                        placeholder={'mymail@provider.com'}
                        caption={'email'}
                        onChange={(e) => (setCreds((c) => ({...c, email: e.target.value})))}
                    />
                    <TextInput
                        type={viewPass ? 'text': 'password'}
                        placeholder={'password'}
                        caption={'password'}
                        onChange={(e) => setCreds((c) => ({...c, password: e.target.value}))}
                        isPassword={true}
                        toggleType={() => setViewPass((v) => !v)}
                    />
                    <button 
                        className={classNames("submit-blog",'input-container', 'flx-c')}
                        onClick={ async() => {
                            if (validateInput()) {
                               const resp = await authenticate(creds.email, creds.password);
                               if (resp?.error) {
                                setOnAlert({
                                    caption: "Invalid Login!",
                                    message: resp?.error
                                });
                               }
                            }
                            //console.log({email:creds.email, password: creds.password})
                        }}
                    >
                        Login
                    </button>
                </div>
            </div>
        </div>
    );
}